module.exports = __webpack_public_path__ + "static/media/Serendipity.25488dd2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Serendipity.ttf
// module id = 3656
// module chunks = 71